import React from 'react';
import {Button, Col, Modal, Row} from 'antd';
import {useTranslation} from 'react-i18next';

// Import the face position images - you may need to adjust these paths based on your asset structure
// import faceStraightFront from '../../assets/face-straight-front.png';
// import faceStraightRight from '../../assets/face-straight-right.png';
// import faceStraightLeft from '../../assets/face-straight-left.png';
// import faceSmileFront from '../../assets/face-smile-front.png';
// import faceSmileLeft from '../../assets/face-smile-left.png';
// import faceSmileRight from '../../assets/face-smile-right.png';
import glasses from '../../assets/removeglass.png';
// import glasses from '../../assets/glasses.svg';
import femaleFigure from '../../assets/pullhair2.png';
// import femaleFigure from '../../assets/female-figure.svg';
// import faceAlign from '../../assets/face-id-align.svg';
import faceAlign from '../../assets/direct.png';
// import faceNoFeeling from '../../assets/facial-no-feeling.svg';
import faceNoFeeling2 from '../../assets/naturalface.png';
import faceSmileFront from "../../assets/no-glasses 1-1.png";
import faceSmileLeft from "../../assets/no-glasses 1-2.png";
import faceSmileRight from "../../assets/no-glasses 1-3.png";
import faceStraightFront from "../../assets/no-glasses 1-4.png";
import faceStraightLeft from "../../assets/no-glasses 1-6.png";
import faceStraightRight from "../../assets/no-glasses 1-5.png";

const CameraInstructionsModal = ({
                                     visible,
                                     onClose,
                                     onContinue,
                                     isVideo = false,
                                     mode = 'fileUpload' // 'fileUpload' or 'survey'
                                 }) => {
    const {t} = useTranslation("common");

    const handleContinue = () => {
        onContinue();
        onClose();
    };

    const renderPhotoInstructions = () => (
        <>
            <Row justify={"start"}>
                <h3>{t("follow_steps")}</h3>
            </Row>
            <Row justify="center" gutter={[32, 16]} className="mt-4">
                <Col span={12} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={glasses} alt="NoGlasses" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("remove_glasses")}</p>
                </Col>
                <Col span={12} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={femaleFigure} alt="PullHairBack" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("pull_hair_back")}</p>
                </Col>
            </Row>

            <Row justify="center" gutter={[32, 16]} className="mt-8">
                <Col span={12} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceAlign} alt="FaceCamera" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("face_camera")}</p>
                </Col>
                <Col span={12} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceNoFeeling2} alt="NoExpression" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("natural_expression")}</p>
                </Col>
            </Row>
        </>
    );

    const renderVideoInstructions = () => (
        <>
            <Row justify={"start"}>
                <h3>{t("video_instruction")}</h3>
            </Row>

            <Row justify={"start"} className="mt-8">
                <h3>{t("neutral_face")}</h3>
            </Row>

            <Row justify="center" gutter={[32, 16]} className="mt-8">
                <Col span={8} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceSmileFront} alt="FaceSmileFront" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("front_view")}</p>
                </Col>
                <Col span={8} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceSmileLeft} alt="FaceSmileLeft" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("slightly_right")}</p>
                </Col>
                <Col span={8} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceSmileRight} alt="FaceSmileRight" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("slightly_left")}</p>
                </Col>
            </Row>
            
            <Row justify={"start"} className="mt-8">
                <h3>{t("smiling_face")}</h3>
            </Row>


            <Row justify="center" gutter={[32, 16]} className="mt-4">
                <Col span={8} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceStraightFront} alt="FaceStraightFront" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("front_view")}</p>
                </Col>
                <Col span={8} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceStraightRight} alt="FaceStraightRight" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("slightly_right")}</p>
                </Col>
                <Col span={8} className="flex flex-col items-center justify-center text-center h-full">
                    <img src={faceStraightLeft} alt="FaceStraightLeft" className="w-[100px] h-[100px] mb-2"/>
                    <p>{t("slightly_left")}</p>
                </Col>
            </Row>

        </>
    );

    return (
        <Modal
            title={t("prepare_skin_analysis")}
            className="whiteModal"
            open={visible}
            onCancel={onClose}
            width={700}

            zIndex={999999}
            footer={null}
        >
            {isVideo ? renderVideoInstructions() : renderPhotoInstructions()}

            <div className="mt-4 flex justify-end">
                <Button
                    type="primary"
                    style={{
                        backgroundColor: "red",
                        borderColor: "red",
                        marginRight: "10px",
                    }}
                    onClick={onClose}
                >
                    {t("cancel")}
                </Button>
                <Button
                    type="primary"
                    style={{
                        backgroundColor: "#8e44ad",
                        borderColor: "#8e44ad",
                    }}
                    onClick={handleContinue}
                >
                    {t("continue")}
                </Button>
            </div>
        </Modal>
    );
};

export default CameraInstructionsModal;
